var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"tcv-context-menu",staticStyle:{"position":"fixed","z-index":"9999","visibility":"hidden","background":"white"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }